import { GuiDetailGeneric } from "../../GuiDetailGeneric";
export class GuiDetailSupportBackgroundTask extends GuiDetailGeneric {
    constructor() {
        super("BackgroundTask");
    }
}
